import React from 'react';
import { Card } from 'react-bootstrap';
import { HorizontalBar } from 'react-chartjs-2';
import { Query } from '@apollo/client/react/components';
import { getAssets } from '../api';
import { Loader } from '../../../components/Loader';
import { verifyRole } from '../../../utils';
import { useSelector } from 'react-redux';

export const InventoryProgressBar = () => {
  const { currentRole } = useSelector((state: any) => ({
    currentRole: state.user.currentRole,
  }));

  const createAssetsQuery = () => {
    if (verifyRole(currentRole.roleName)) return getAssets(null, currentRole.source);
    return getAssets(currentRole.departmentId, currentRole.source);
  };

  return (
    <Query query={createAssetsQuery()}>
      {({ loading, error, data }: any) => {
        if (error) return <div>{JSON.stringify(error)}</div>;
        if (loading) return <Loader />;

        let percentComplete = '0';
        let progressMessage = '';
        if (data.total_count === 0) {
          progressMessage = 'Are assets set up?';
        } else {
          percentComplete = ((data.scanned_count / data.total_count) * 100).toFixed(0);
          progressMessage = `${data.scanned_count} Inventoried, ${data.total_count - data.scanned_count} TBD, ${percentComplete}% Complete `;
        }

        return (
          <div className='m-5'>
            <h2>Progress: {progressMessage}</h2>
            <Card className=''>
              <div style={{ height: '60px' }}>
                <HorizontalBar
                  data={{
                    labels: ['Items'],
                    datasets: [
                      {
                        label: 'Scanned Items',
                        data: [data.scanned_count],
                        backgroundColor: '#00bc8c',
                      },
                    ],
                  }}
                  options={{
                    maintainAspectRatio: false,
                    legend: { display: false },
                    scales: {
                      xAxes: [
                        {
                          ticks: {
                            beginAtZero: true,
                            max: data.total_count,
                          },
                        },
                      ],
                    },
                  }}
                />
              </div>
            </Card>
          </div>
        );
      }}
    </Query>
  );
};
